export const beeScorecardUserAccess = 'BEEScorecardUserAccess/';
export const GetBEEScorecardUserAccess = beeScorecardUserAccess + 'GetScorecardUserAccess';
export const GetEEScorecardUserAccess = beeScorecardUserAccess + 'GetEEScorecardUserAccess';
export const AddScorecardUserAccess = beeScorecardUserAccess + 'AddScorecardUserAccess';
export const SaveScoreCardUserAccess = 'BEEScorecard/SaveScorecardUserAccess';
export const GetAllScorecardUserAccessByType = 'BEEScorecard/GetAllScorecardUserAccessByType';
export const SearchLinkedScorecardUserAccessById = 'BEEScorecard/SearchLinkedScorecardUserAccess';
export const AvailableScorecardUserAccessById = 'BEEScorecard/AvailableScorecardUserAccessById';